import { IconEyeOff, IconTrash } from '@tabler/icons-react-native';
import { Column, Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { useUpdateOneListing } from 'app/network/listing';
import type { PostSaleListingMessage } from 'app/types/chat';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function PostSaleListingMessageCard({ message }: { message: PostSaleListingMessage }) {
  const { t } = useTranslation('one-channel');
  const [hidden, setHidden] = useState(false);
  const updateListing = useUpdateOneListing(message.data.listingId, { onSuccess: () => setHidden(true) });

  if (hidden) return null;

  return (
    <Column
      gap="spacing.general.x4"
      padding="spacing.general.x4"
      backgroundColor="surface.primary-neutral"
      borderRadius="radius.lg"
    >
      <Text fontSize={14} fontWeight="700">
        {t('postSaleListingPrompt.title')}
      </Text>
      <Text fontSize={14}>{t('postSaleListingPrompt.description')}</Text>
      <Row gap="spacing.general.x2">
        <Button
          flex={1}
          onPress={() => setHidden(true)}
          variant="secondary"
          justifyContent="center"
          alignItems="center"
        >
          {t('postSaleListingPrompt.keep')}
        </Button>
        <Button
          flex={1}
          loading={updateListing.isPending}
          onPress={() => updateListing.mutate({ status: 'archived' })}
          prefix={<IconEyeOff size={20} strokeWidth={ICON_STROKE_WIDTH} />}
          textAlign="center"
          variant="secondary"
        >
          {t('postSaleListingPrompt.hide')}
        </Button>
        <Button
          flex={1}
          loading={updateListing.isPending}
          onPress={() => updateListing.mutate({ status: 'deleted' })}
          prefix={<IconTrash color="white" size={20} strokeWidth={ICON_STROKE_WIDTH} />}
          textAlign="center"
          variant="primary"
        >
          {t('postSaleListingPrompt.delete')}
        </Button>
      </Row>
    </Column>
  );
}
